import React from 'react';
import { WorkerSlackChannel } from '@scale/shared/workerSlack/types';
import SlackChannelActionsDefaultChannel from './SlackChannelActionsDefaultChannel';
import SlackChannelActionsEditChannel from './SlackChannelActionsEditChannel';
import SlackChannelActionsRecommendedChannel from './SlackChannelActionsRecommendedChannel';
import SlackChannelActionsRemoveChannel from './SlackChannelActionsRemoveChannel';
import SlackChannelActionsAddChannel from './SlackChannelActionsAddChannel';

interface ISlackChannelActionsProps {
  channel: WorkerSlackChannel;
  isLoading: boolean;
  isAdd?: boolean;
  isRemove?: boolean;
  isCurrent?: boolean;
  isRecommended?: boolean;
  isHover?: boolean;
  copied?: boolean;
  isEditable?: boolean;
  setCopied?: (copied: boolean) => void;
  editPermissionReviewLevel?: (reviewLevels: $FIXME[]) => void;
  editPermissionWorkerSources?: (workerSources: $FIXME[]) => void;
  editPermissionCountries?: (countries: $FIXME[]) => void;
}

const SlackChannelActions = (props: ISlackChannelActionsProps) => {
  return (
    <>
      {props.isEditable && (
        <div className="item-actions-container">
          {props.isAdd ? (
            <SlackChannelActionsAddChannel {...props} />
          ) : props.isRemove ? (
            <SlackChannelActionsRemoveChannel {...props} />
          ) : props.isRecommended ? (
            <SlackChannelActionsRecommendedChannel {...props} />
          ) : props.channel.toEdit ? (
            <SlackChannelActionsEditChannel {...props} />
          ) : (
            <SlackChannelActionsDefaultChannel {...props} />
          )}
        </div>
      )}
      <style jsx>{`
        .item-actions-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActions;
